import { oc } from '@orpc/contract';
import { getPolicyVersionInputSchema, policyVersionSchema } from '../schemas/policies.schemas.js';
export const getPolicyVersionContract = oc
    .route({
    method: 'GET',
    path: '/policies/versions/{versionId}',
    tags: ['Policies'],
    summary: 'One policy version with its equations',
})
    .input(getPolicyVersionInputSchema)
    .output(policyVersionSchema);
//# sourceMappingURL=get-policy-version.contract.js.map